import React from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

import { extraErrorDataIntegration } from '@sentry/integrations'
import * as Sentry from '@sentry/react'

import { getToken } from './token'

const {
  REACT_APP_NODE_ENV,
  REACT_APP_SENTRY_CLIENT,
  REACT_APP_SENTRY_ERROR_RATE,
  REACT_APP_SENTRY_TRACES_RATE,
} = process.env

const errorBlocklist = [
  'A sua nova senha não pode ser igual a senha atual.',
  "Can't find variable: gmo",
  'Code: 0',
  'Code: 002',
  'Code: 003',
  'Code: 006',
  'Code: 007',
  'Code: 013',
  'Código de acesso já está ativo.',
  'Código expirado. Peça um novo código à coordenação da sua escola.',
  'Código inválido. Verifique se você digitou corretamente.',
  'E-mail inválido',
  'Erro ao validar o código.',
  'Esse e-mail já está sendo utilizado em uma conta de aluno. Por favor, informe outro.',
  'Esse número de celular já está cadastrado.',
  'Esta conta está inativa.',
  'Este e-mail já está em uso. Tente outro.',
  'Este nome de usuário',
  'já está em uso. Tente outro.',
  'Failed to fetch',
  'GraphQL error: Authorization token',
  'Java exception was raised during method invocation',
  'Load failed',
  'Login ou senha não encontrados.',
  'Network Error',
  'NetworkError',
  'Número de celular inválido.',
  'O Código de acesso digitado não corresponde com o enviado.',
  'O código de acesso informado está expirado.',
  'O código de acesso informado já foi utilizado.',
  'O código de validação digitado não foi encontrado.',
  'O nome de usuário deve ter mais de 5 caracteres (letras, números, ponto, hífen ou sublinhado)',
  'O responsável',
  'O usuário informado não é um Aluno.',
  'Ops, esse código de acesso é de equipe escolar!',
  'já está vinculado a essa conta de aluno. Por favor, informe outro e-mail.  ',
  'Request failed with status code',
  'Senha muito fraca. Combine letras e números (mínimo de 8 caracteres).',
  `Unexpected token 'B', "Bearer tok"... is not valid JSON`,
  'Unexpected token B in JSON at position 0',
  'Você solicitou o código de verificação recentemente. Por favor, espere um momento e depois tente pedir o código novamente.',
  'client: undefined - getActivesYears, usuário sem token.',
  'gtag',
  'n is not a function',
]

let environment = REACT_APP_NODE_ENV
if (environment === 'pull_request') {
  environment = 'staging'
}

const beforeSendFiltering = (event, hint) => {
  if (hint?.originalException) {
    const message = hint.originalException.message || hint.originalException
    const foundBlockListedTerm = !!errorBlocklist.filter(error =>
      message.toLowerCase().includes(error.toLowerCase()),
    ).length
    if (foundBlockListedTerm) {
      return null
    }
  }
  return event
}

const setUser = () => {
  const userLocal = localStorage?.getItem(`_plurall_user_${getToken()}`)
  if (userLocal) {
    const user = JSON.parse(userLocal)
    Sentry.setUser({
      id: user.somos_id,
      plurall_id: user.plurall_id,
    })
  }
}

export function initSentry() {
  if (REACT_APP_SENTRY_CLIENT && environment !== 'local') {
    Sentry.init({
      dsn: REACT_APP_SENTRY_CLIENT,
      environment,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV6Instrumentation(
            React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          ),
        }),
        extraErrorDataIntegration({ depth: 5 }),
      ],
      normalizeDepth: 5,
      sampleRate: +REACT_APP_SENTRY_ERROR_RATE,
      tracesSampleRate: +REACT_APP_SENTRY_TRACES_RATE,
      beforeSend: beforeSendFiltering,
      ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured'],
    })
    setUser()
  }
}
